import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { ErrorBoundary } from './components/ErrorBoundary';

const DemoHub = lazy(() =>
  import('./pages/DemoHub.js').then((m) => ({ default: m.DemoHub })),
);

const DemoShell = lazy(() =>
  import('./components/demo/DemoShell.js').then((m) => ({
    default: m.DemoShell,
  })),
);

const ArenaPage = lazy(() =>
  import('./pages/ArenaPage.js').then((m) => ({ default: m.ArenaPage })),
);

const SandboxPage = lazy(() =>
  import('./pages/SandboxPage.js').then((m) => ({ default: m.SandboxPage })),
);

const PitchDeckPage = lazy(() =>
  import('./pages/PitchDeckPage.js').then((m) => ({ default: m.PitchDeckPage })),
);

const LoadingFallback = () => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      background: 'var(--md-sys-color-surface)',
    }}
  >
    <md-circular-progress indeterminate />
  </div>
);

export default function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route
            path="/demo"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <DemoHub />
              </Suspense>
            }
          />
          <Route
            path="/demo/closures"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <DemoShell />
              </Suspense>
            }
          />
          <Route
            path="/arena"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <ArenaPage />
              </Suspense>
            }
          />
          <Route
            path="/sandbox"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <SandboxPage />
              </Suspense>
            }
          />
          <Route
            path="/pitch-deck"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <PitchDeckPage />
              </Suspense>
            }
          />
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}
